module.exports = __webpack_public_path__ + "media/images/underconstruction-1b2af66ef02c0253e8262991e0f19889.png";